
//header hamburder_menu

const ham = $('#js-hamburger');
const nav = $('#js-nav');
ham.on('click', function () {
  ham.toggleClass('active');
  nav.toggleClass('active');
  var $indexHero = $('header.header--index-hero');
  if ($indexHero.length) {
    $indexHero.toggleClass('header--index-nav-open', nav.hasClass('active'));
  }
});


//sp header size animation

// var isAnimating = false;

$(function() {
  $(window).on('load resize scroll', function() {

      // if(isAnimating){
      //   return;
      // }
      var scrollPos = $(this).scrollTop();

      var $indexHeader = $('header.header--index-hero');
      if ($indexHeader.length) {
        var wasScrolled = $indexHeader.hasClass('header--index-scrolled');
        var nowScrolled = scrollPos > 0;
        $indexHeader.toggleClass('header--index-scrolled', nowScrolled);
        if (nowScrolled && !wasScrolled) {
          var headerSwiperEl = document.querySelector('header.header--index-hero .header_swiper');
          if (headerSwiperEl && headerSwiperEl.swiper) {
            headerSwiperEl.swiper.update();
          }
        }
      }
      var headerTitle = $('.header_title');
      var screenWidth = $(window).width();

      // isAnimating = true;

      if (screenWidth >= 1051) {
          if (scrollPos > 100) {
              $('header, .header_inner').addClass('js-animation');
              // headerTitle.animate({'margin-top': '0'}, 200, () => { isAnimating = false; });
          } else {
              $('header, .header_inner').removeClass('js-animation');
              // headerTitle.animate({'margin-top': '0'}, 200, () => { isAnimating = false; });
          }
      } else {
          if (scrollPos > 100) {
              $('header, .header_inner').addClass('js-animation');
              // headerTitle.animate({'margin-top': '20px'}, 200, () => { isAnimating = false; });
          } else {
              $('header, .header_inner').removeClass('js-animation');
              // headerTitle.animate({'margin-top': '30px'}, 200, () => { isAnimating = false; });
          }
      }
  });
});


//header swiper

var swiper = new Swiper(".header .swiper", {
  loop: true,
  speed: 1500,
  slidesPerView: 1,
  centeredSlides: true,
  autoplay: {
    delay: 5000, 
  },
});

//top swiper

var swiper = new Swiper("#main_visual .swiper", {
  loop: true,
  speed: 1500,
  slidesPerView: 1,
  centeredSlides: true,
  autoplay: {
    delay: 5000, 
  },
  pagination: {
    el: '.swiper-pagination',
    progressbarOpposite: true,
    clickable: true
  },
  effect: 'fade',
});



//FAQ modal

$(function () {

  $('.modal_open').click(function () {

    $('.modal_bg').fadeIn();

    var modal = '#' + $(this).attr('data-target');
    $(modal).fadeIn();
    modalResize(modal);
    $(window).on('resize', function () {
      modalResize(modal);
    });

  });

  $('.modal_bg, .modal_close').off().click(function () {
    $('.modal_box').fadeOut();
    $("#modal_back").attr('data-target', 'page1');
    $("#modal_back").attr('data-name', '');
    $('.modal_bg').fadeOut('slow', function () {
      $("#modal_back").fadeOut();
      $("#modal__container").removeClass("second");
      $("#modal__container").removeClass("third");
    });
  });

  $('.modal_switch').off().click(function () {

    var modal = '#' + $(this).attr('data-target');
    var name = $(this).attr('data-name');

    $("#modal__container").removeClass("second");
    $("#modal__container").removeClass("third");

    if(modal == "#page1"){

      $("#modal_back").fadeOut();

      setTimeout(() => {
        $(".modal_link.second").hide();
        $(".modal_answer.third").hide();
      }, 500);

    }else if(modal == "#page2"){

      $("#modal_back").attr('data-target', 'page1');
      $("#modal_back").attr('data-name', '');
      $("#modal_back").fadeIn();

      $("#modal__container").addClass("second");
      if(!name || name == "" || name == undefined){
        return;
      }
      $(modal+"-"+name).show();
      setTimeout(() => {
        $(".modal_answer.third").hide();
      }, 500);

    }else if(modal == "#page3"){

      $("#modal_back").attr('data-target', 'page2');
      $("#modal_back").attr('data-name', name.split('-')[0]);
      $("#modal_back").fadeIn();

      $("#modal__container").addClass("third");
      if(!name || name == "" || name == undefined){
        return;
      }
      $(modal+"-"+name).show();
      setTimeout(() => {
        $(".modal_link.second").hide();
      }, 500);

    }
  });

});


function modalResize(e) {
  var w = $(window).width();
  var h = $(window).height();
  var margin = 30;

  if (w <= 767) {
    x = (w - $(e).outerWidth(true)) / 2;
    y = h - $(e).outerHeight(true) - 30;
  } else {
    x = (w - $(e).outerWidth(true))  - 30;
    y = (h - $(e).outerHeight(true))  - 30;
  }

  $(e).css({ 'left': x + 'px', 'top': y + 'px' });
}


//scroll fade

$(function(){
  $(window).scroll(function (){
    $('.js_fade').each(function(){
      var pos = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll > pos - windowHeight + 100){
        $(this).addClass('scroll');
      }
    });
  });
});


//product_detail image swiper

var swiperMain = new Swiper('#product_detail .swiper-container', {
  autoHeight: true,
  speed: 500,
  loop: true,
 //  navigation: {
 //  nextEl: '.swiper-button-next',
 //  prevEl: '.swiper-button-prev',
 // },
});

function slideThumb(index) {
 swiperMain.slideTo(index);
}


var swiperDetailWrapping = new Swiper('#product_detail .swiper', {
  speed: 500,
  loop: true,
  navigation: {
  nextEl: '.swiper-button-next',
  prevEl: '.swiper-button-prev',
 },
});


//product_detail wrapping swiper

$(document).ready(function() {
  var swiper = new Swiper("#wrapping .swiper", {
    loop: true,
    speed: 500,
    autoplay: false,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
});


//product_detail　accordion

$(function(){
  $(".label").on("click", function() {
    $(this).next().slideToggle();
    $(this).toggleClass("open");
  });
});


//product_detail　accordion

$(".btn_sns").on("click", function() {
  $(".sns_modal")
    .addClass("show")
    .fadeIn();
  // return false;
});

$("#close").on("click", function() {
  $(".sns_modal").fadeOut();
  // return false;
});




